var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinusRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3500_1035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57143 1.25C1.15313 1.25 0 2.37109 0 3.75V16.25C0 17.6289 1.15313 18.75 2.57143 18.75H15.4286C16.8469 18.75 18 17.6289 18 16.25V3.75C18 2.37109 16.8469 1.25 15.4286 1.25H2.57143ZM6.10714 9.0625H11.8929C12.4272 9.0625 12.8571 9.48047 12.8571 10C12.8571 10.5195 12.4272 10.9375 11.8929 10.9375H6.10714C5.57277 10.9375 5.14286 10.5195 5.14286 10C5.14286 9.48047 5.57277 9.0625 6.10714 9.0625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3500_1035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20.5714,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusRemove);
export default __webpack_public_path__ + "static/media/minus-remove.3d4b9e42fd439cf9db3a9fcd52746d7b.svg";
export { ForwardRef as ReactComponent };